<template>

<app-page :title="title">

    <com-admin v-if="$isAdmin" />
    <com-organisation v-if="$isOrganisation" />
    <com-clinic v-if="$isClinic" />
    <com-data v-if="$isData" />

</app-page>

</template>

<script>

import comAdmin from './dashboard/Admin'
import comOrganisation from './dashboard/Organisation'
import comClinic from './dashboard/Clinic'
import comData from './dashboard/Data'

export default {

    components: {
        'com-admin': comAdmin,
        'com-organisation': comOrganisation,
        'com-clinic': comClinic,
        'com-data': comData    
    },

    computed: {
    
        title: function() {
        
            if (this.$isOrganisation) return 'Organisation Report'
            if (this.$isClinic) return 'Clinic Report'
            if (this.$isData) return 'Data Report'

            return 'Admin Dashboard'
        
        }
    
    }

}

</script>

<style scoped>

</style>
